import React from 'react';

const SidePostGroupSub = ({ posts }) => {
    // 根據文章數量決定標籤顏色
    const getBadgeColor = (count) => {
        if (count >= 15) return 'high';
        if (count >= 8) return 'medium';
        return 'low';
    };

    return (
        <div className='category-item'>
            <a className='category-link' href={`/p?ci=${posts.categoryId}`}>
                <div className='category-content'>
                    <div className='category-info'>
                        <h3 className='category-name'>{posts.categoryName}</h3>
                        <div className='category-stats'>
                            <span className={`category-count ${getBadgeColor(posts.postCount)}`}>
                                {posts.postCount} 篇文章
                            </span>
                        </div>
                    </div>
                </div>
                <div className='category-arrow'>
                    <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                    </svg>
                </div>
            </a>
        </div>
    );
};

export default SidePostGroupSub;